import { DefaultDialog } from "components/DefaultDialog";
import { useRedirectAndScroll } from "hooks";
import { useAuth } from "providers/auth-provider";
import { useTranslates } from "providers/translates";
import { vacHeaderLabel } from "utilities/vac-copy";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { RoutesName } from "routs";
import { STEP_FOUR_SNAPSHOT_KEY, STEP_ONE_SNAPSHOT_KEY, STEP_THREE_SNAPSHOT_KEY, STEP_TWO_SNAPSHOT_KEY } from "components/CreateMemorialQuiltComponents/constants/constants";

const CreateQuiltButton: React.FC = () => {
  const { onlyRedirect } = useRedirectAndScroll({});
  const { id } = useParams();
  const { isAuthorized, user } = useAuth();
  const { translates:t, selectedLang } = useTranslates();
  const createQuiltLabel = vacHeaderLabel(selectedLang, t?.header?.createQuilt, 'createQuilt', 'Create a Memorial');
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const handleConfirmDialogOpen = () => {
    setOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setOpen(false);
  };

  const goToNewQuilt = () => {
    localStorage.removeItem(STEP_ONE_SNAPSHOT_KEY);
    localStorage.removeItem(STEP_TWO_SNAPSHOT_KEY);
    localStorage.removeItem(STEP_THREE_SNAPSHOT_KEY);
    localStorage.removeItem(STEP_FOUR_SNAPSHOT_KEY);

    user?.isInvitedUser
      ? onlyRedirect(RoutesName.SignUp)
      : onlyRedirect(`${RoutesName.CreateQuilt}?step=1`);
    handleConfirmDialogClose();
    window.location.reload();
  };

  return (
    <div>
      {location.pathname !== `/update/${id}` ? (
        <span
          onClick={() => {
            isAuthorized && !user?.isInvitedUser
              ? onlyRedirect(`${RoutesName.CreateQuilt}?step=1`)
              : onlyRedirect(RoutesName.SignUp);
          }}
        >
          {createQuiltLabel}
        </span>
      ) : (
        <>
          <span onClick={handleConfirmDialogOpen}>
            {createQuiltLabel}
          </span>

          <DefaultDialog
            open={open}
            setDialog={handleConfirmDialogClose}
            title={
              t?.header?.createANewQuiltConfirmDialogTitle ||
              'Are you sure you want to exit the editable quilt?'
            }
            text={
              t?.header?.createANewQuiltConfirmDialogContent ||
              'All unsaved changes may be lost!'
            }
            cancelBtnText={
              t?.header?.createANewQuiltConfirmDialogCancelBtnLabel || 'Stay'
            }
            confirmBtnText={
              t?.header?.createANewQuiltConfirmDialogConfirmBtnLabel ||
              'New quilt'
            }
            confirmAction={goToNewQuilt}
          />
        </>
      )}
    </div>
  );
}

export { CreateQuiltButton };
